import * as React from 'react';
import { differenceInCalendarMonths } from 'date-fns';
import { compose } from 'recompose';
import { createStyles, Grid, Paper } from '@material-ui/core';
import Month from '../DateRangePickerComponentMonth';
import DefinedRanges from '../DateRangePickerComponentDefinedRanges';
import { MARKERS } from '../../types';
import { border, toCssValue } from '@topconagriculture/theme';
import { withBaseProps } from '../../../../Utils';
const styles = (theme) => createStyles({
    header: {
        padding: toCssValue([theme.space.padding.default, theme.space.padding.largest]),
    },
    headerItem: {
        flex: 1,
        textAlign: 'center',
    },
    divider: {
        borderLeft: border(theme.palette.action.hover, 1, 'solid'),
        margin: toCssValue([theme.space.margin.small, 0]),
        zIndex: 1,
        width: 2,
    },
    root: {
        padding: toCssValue([4, 8]),
    },
});
const DateRangePickerComponentMenu = (props) => {
    const { classes, ranges, locale, dateRange, minDate, maxDate, firstMonth, setFirstMonth, secondMonth, setSecondMonth, setDateRange, handlers, testId, disableSelectMonthDropdown, weekStartsOn, dateFormat, maxRangeInMonths, } = props;
    const canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 1;
    const commonProps = { dateRange, minDate, maxDate, handlers };
    return (React.createElement(Paper, { className: classes.root, elevation: 5, square: true, "data-testid": `${testId}` },
        React.createElement(Grid, { container: true, direction: "row", wrap: "nowrap" },
            React.createElement(Grid, null,
                React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", wrap: "nowrap" },
                    React.createElement(Month, Object.assign({}, commonProps, { value: firstMonth, dateFormat: dateFormat, setValue: setFirstMonth, navState: [true, canNavigateCloser], marker: MARKERS.FIRST_MONTH, disableSelectMonthDropdown: disableSelectMonthDropdown, locale: locale, weekStartsOn: weekStartsOn })),
                    React.createElement("div", { className: classes.divider }),
                    React.createElement(Month, Object.assign({}, commonProps, { value: secondMonth, dateFormat: dateFormat, setValue: setSecondMonth, navState: [canNavigateCloser, true], marker: MARKERS.SECOND_MONTH, disableSelectMonthDropdown: disableSelectMonthDropdown, locale: locale, weekStartsOn: weekStartsOn, maxRangeInMonths: maxRangeInMonths })),
                    React.createElement("div", { className: classes.divider }))),
            React.createElement(Grid, null,
                React.createElement(DefinedRanges, { selectedRange: dateRange, ranges: ranges, setRange: setDateRange })))));
};
export default compose(withBaseProps({ styles }))(DateRangePickerComponentMenu);
//# sourceMappingURL=DateRangePickerComponentMenu.js.map